import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyAssignCustomRoles = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-assign-custom-roles", jiraSpaEntry: "async-jira-eoc-assign-custom-roles" */ '@atlassian/jira-eoc-assign-custom-roles'
		),
);

const AsyncAssignCustomRoles = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAssignCustomRoles}
		pageId="async-eoc-assign-custom-roles"
		shouldShowSpinner={false}
	/>
);

export default AsyncAssignCustomRoles;
